<template>
  <div class='shop-verify-container'>
    <div class="status-img-wrapper">
      <img :src=verify.image>
    </div>
    <p class="page-title">{{ verify.title }}</p>
    <p class="page-intro" v-if='num === 1'>{{ verify.content }}</p>
    <p class="page-intro" v-else>{{ verify.content }}您可以关注【国花瓷消费者】服务公众号查看更多信息。</p>
    <p class="page-intro" v-if="button">审核意见：{{ verify.verifyRemark }}</p>
    <div class="qrcode-img-wrapper">
      <img v-if="num === 1" src="../../assets/img/img_little.png">
      <img v-else src="../../assets/img/img_qrcode_1.png">
      <p v-if="num === 1">长按二维码打开【国花瓷渠道通】小程序</p>
      <p v-else>长按二维码关注【国花瓷消费者】服务号</p>
    </div>
    <button class="btn" v-if="button" @click="reapply">修改并重新提交</button>
  </div>
</template>

<script>

import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)

export default {
  name: 'ShopVerify',
  data() {
    return {
      num: '',
      verify: {},
      rejectData: {},
      button: false,
      verifyInfo: [
        {
          image: require('../../assets/img/img_register_waiting.png'),
          title: '资料审核中',
          content: '您的申请我们已经收到，正在加紧为您审核。'
        },
        {
          image: require('../../assets/img/img_success.png'),
          title: '审核通过',
          content: '欢迎您加入国花瓷零售户服务体系。'
        },
        {
          image: require('../../assets/img/img_reject.png'),
          title: '审核被拒',
          content: '您的申请审核被拒绝，请修改资料重新申请。',
          verifyRemark: ''
        }
      ]
    }
  },
  created() {
    this.num = this.$route.params.status
    switch (this.num) {
      case 0:
        this.verify = this.verifyInfo[0]
        break
      case 1:
        this.verify = this.verifyInfo[1]
        break
      case 2:
        this.verify = this.verifyInfo[2]
        this.rejectData = this.$route.params.rejectData
        this.verify.verifyRemark = this.rejectData.verify_remark
        console.log(this.rejectData)
        this.button = true
        break
      case 3:
        this.verify = this.verifyInfo[3]
        break
      default:
        this.verify = this.verifyInfo[0]
    }
  },
  computed: {
  },
  methods: {
    handle() {
    },
    reapply() {
      this.$router.push({ name: 'ShopRegister', params: { reapplyData: this.rejectData }})
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-verify-container {
  width: 100%;
  height: 100%;
  background: #fff;
  .status-img-wrapper {
    position: relative;
    top: 60px;
    img {
      width: 62px;
      height: 62px;
      display: block;
      margin: 0 auto;
    }
  }
  .page-title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #4A4A4A;
    text-align: center;
    width: 200px;
    margin: 72px auto 0;
  }
  .page-intro {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #747474;
    text-align: center;
    width: 268px;
    margin: 10px auto;
  }
  .qrcode-img-wrapper {
    margin: 5px 0;
    text-align: center;
    img {
      width: 186px;
      height: 186px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #747474;
      letter-spacing: -0.35px;
    }
  }
  .btn {
      width: 345px;
      height: 40px;
      margin: 10px 20px;
      background: #003485;
      color: #fff;
      font-size: 14px;
      border: none;
      border-radius: 20px;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/shop/verify.vue